import React, { Component } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import TableBody from './TableBody';
import TableCell from './TableCell';
import TableFooter from './TableFooter';
import TableHeader from './TableHeader';
import TableRow from './TableRow';

import './Table.scss';

class Table extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
  };

  static Header = TableHeader;
  static Body = TableBody;
  static Footer = TableFooter;
  static Row = TableRow;
  static Cell = TableCell;

  render() {
    const { children, className } = this.props;
    const classComponent = classNames('table', className);

    return (
      <div role="table" aria-label="Table" className={classComponent}>
        {children}
      </div>
    );
  }
}

export default Table;
